module.exports = __webpack_public_path__ + "img/attach_icon.e71f8939.svg";